module.exports = __webpack_public_path__ + "static/media/karma1.d046f0fb.jpg";